// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"892769e5","455":"aad6f73b","977":"677acb6a"}[chunkId] + ".chunk.js";
};